module.exports = __webpack_public_path__ + "static/assets/0113ff98f5b42f42a53702f1e8db9499.png";